import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, dateUTCShedule, dateLocal, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import Calendar from 'react-calendar';
import Scheduler from '../components/schedule/scheduler';
//import ScheduleAdd from '../components/schedule/add';
//import ScheduleEdit from '../components/schedule/edit';
import OrganiserEdit from '../components/organiser/edit';
import EnImage from '../components/image/image';

import Blocks from '../components/bbcode/blocks';
//import CopyBox from '../components/bbcode/copybox';
//import VideoPlayer from '../components/video/video';
import Genres from '../components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';


//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/stream.css';
//import './css/header.css';
import './css/schedule.css';

class PortalServiceSchedule extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: parseInt(this.props.service),
				name: '',
			},

			
			date: new Date(),
      
			
			organiser: [],
			schedule: [],
			
			djs: [],

			showModal: false,
			filename_flyer: false,
      
			
			ListenerSchedule: null,
			

		};
    this.getSchedule = this.getSchedule.bind(this);
		this.setDate = this.setDate.bind(this);
		this.setMonth = this.setMonth.bind(this);
		this.showModal = this.showModal.bind(this);
		this.organiserEdit = this.organiserEdit.bind(this);
		this.scheduleZone = this.scheduleZone.bind(this);
		this.clickuploadFlyer = this.clickuploadFlyer.bind(this);
		this.uploadFlyer = this.uploadFlyer.bind(this);
  };

  async componentDidMount() {
		//document.title = "";
		

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		//value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', y);


		this.getSchedule(server);

		//---- Schedule updates
		const ListenerSchedule = EventEmitter.addListener(`/service/schedule`, async data => {
			if( data.service === this.state.service.id ) await this.getSchedule();
		}); this.setState({ListenerSchedule});

	}

	componentWillUnmount() {
    if( this.state.ListenerSchedule ) this.state.ListenerSchedule.remove();
	}

	async getSchedule(server = null) {

		if( !server ) {
			const value = this.context;
			server = value.worker[this.props.service];
		}

		let d = dateUTCShedule(this.state.date);
		/*let e = dateUTCShedule(this.state.date, -1, -1, 1);
		let f = dateUTCShedule(e);
			f.setMonth(f.getMonth()+1);
			f.setDate(f.getDate()-1);*/

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('schedule', Math.floor(d.getTime()/1000));
		//params.append('start',Math.floor(e.getTime()/1000));
		//params.append('end',Math.floor(f.getTime()/1000));
		const x = await postApi(`${server}/v3/service/schedule`, params);
		consoleLog(x.data);
		let service = this.state.service;
		if( x.status === 200 ) {
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Schedule', x.data.servicename);
			}
			this.setState({organiser: [], schedule: [{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: "2025-04-01T00:00:00.000Z",
				description: "",
				end: "2025-04-02T04:00:00.000Z",
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: "2025-04-01T22:00:00.000Z",
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: "2025-04-01T00:00:00.000Z",
				description: "",
				end: "2025-04-02T04:00:00.000Z",
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: "2025-04-01T22:00:00.000Z",
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: "2025-04-01T00:00:00.000Z",
				description: "",
				end: "2025-04-02T04:00:00.000Z",
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: "2025-04-01T22:00:00.000Z",
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: "2025-04-01T00:00:00.000Z",
				description: "",
				end: "2025-04-02T04:00:00.000Z",
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: "2025-04-01T22:00:00.000Z",
				timezone: "America/Detroit",
				zone: 0
			},{
				avatar: null,
				color: "ffffff99",
				cover: null,
				date: "2025-04-01T00:00:00.000Z",
				description: "",
				end: "2025-04-02T04:00:00.000Z",
				events: [],
				genres: [],
				id: 0,
				length: 60,
				oid: 0,
				showname: "",
				start: "2025-04-01T22:00:00.000Z",
				timezone: "America/Detroit",
				zone: 0
			}]},()=>{
				this.setState({organiser: x.data.organiser, schedule: x.data.schedule});
			});
		}
	}


	setDate(e) {
		this.setState({date: e}, ()=>this.getSchedule());
	}


	setMonth(e) {
		if( e.activeStartDate ) this.setState({date: e.activeStartDate, events: []}, ()=>this.getSchedule());
	}


	timeAgo(time) {
		const _time = Math.floor( Math.abs((Date.now()/1000) - time) / 60) ;
		let past = time < Math.floor(Date.now()/1000);
		let _return = '';
		if( _time >= 10 ) _return = Math.floor(_time).toString() + " mins";
		if( _time >= 60 ) _return = Math.floor(_time/60).toString() + " hour" + (Math.floor(_time/60)>1?"s":"");
		if( _time >= 1440 ) _return = Math.floor(_time/1440).toString() + " day" + (Math.floor(_time/1440)>1?"s":"");
		return( <>{!past&&'In '}{_return}{past&&' ago'}</> );
	}


	showModal(event) {
		this.setState({showModal: event});
	}


	organiserEdit(e, date) {
		for( let i in this.state.organiser ) {
			if( date === this.state.organiser[i].date ) {
				console.log(i, date, this.state.organiser[i]);
				this.setState({showModal: {option: 'organiseredit', id: parseInt(i)}});
			}
		}
	}

	async scheduleZone(zone) {
		const value = this.context;
		//this.setState({schedule_zone: zone},()=>{
			
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('zone', zone);
			//const value = this.context;
			await putApi(`${value.worker[this.state.service.id]}/v3/service/timezone`, params);
			this.getSchedule();
		//});
	}

	close = (childData) => {
    this.setState({showModal: false}, () => {
			this.getSchedule();
		});
	}


	clickuploadFlyer(date) {
		consoleLog(date);
		this.setState({filename_flyer: date},()=>{
			document.getElementById(`upload_flyer`).click();
		});
	}

	async uploadFlyer(event) {
		const value = this.context;
		const params = new FormData();
		params.append('service', this.state.service.id);
		params.append('files', event.target.files[0]);
		params.append('path', `radio/${this.state.service.id}/flyer/${this.state.filename_flyer}/`);
		//params.append('type', 'flyer');
		//params.append('cover', this.state.filename_flyer);
		consoleLog(event.target.files[0]);
		await putApi(`/v3/upload`, params);

		let params2 = new URLSearchParams();
		params2.append('service', this.state.service.id);
		params2.append('cover', this.state.filename_flyer);
		params2.append('name', event.target.files[0].name.replaceAll(' ',''));

		await postApi(`${value.worker[this.state.service.id]}/v3/service/schedule/flyer`, params2);

		this.setState({filename_flyer: false},()=>{
			this.getSchedule();
		});
	}
  
	render() {
		const user = this.context;

		const shows = ({ date, view }) => {
			if (view === "month") {
				let found = false;
				for( let i in this.state.organiser ) {
					let timezone = new Date();
					let day = Math.abs(Math.floor(date.getTime()/1000) - dateLocal(this.state.organiser[i].date)-timezone.getTimezoneOffset()*60);
					if( day <= 3600 ) {
						found = true;
						return <React.Fragment key={i}>
							{this.state.organiser[i].cover && this.state.organiser[i].cover.length > 0 ?
								<div className="schedule-event-cover d-none d-md-block" style={{border: '1px solid #000000', backgroundImage: `url(https://cloud.ultrastream.io${this.state.organiser[i].cover})`, backgroundSize: 'cover', height: '100%', color: '#333333'}}>
									<div style={{position: 'absolute', bottom: 0, width: '50%', left: '25%', height: 20, lineHeight: '20px', backgroundColor: '#ffffff'}}>{moment(dateLocal(this.state.organiser[i].date)*1000).format("DD MMM")}</div>
								</div>
							:
								<div className="d-none d-md-block" style={{border: '1px solid #000000', /*backgroundColor: `#${this.state.organiser[i].color}`*/
									backgroundImage: `url(https://cloud.ultrastream.io/images/components/background.png)`, backgroundSize: 'cover', color: '#000000'}}>
										<div className="schedule-event p-0" style={{backgroundColor: `#${this.state.organiser[i].color}`}}>
									<span>
										{this.state.organiser[i].showname&&this.state.organiser[i].showname.length>0?this.state.organiser[i].showname:moment(dateLocal(this.state.organiser[i].date)*1000).format("dddd")}<br />
										{moment(dateLocal(this.state.organiser[i].date)*1000).format("DD MMM")}
										{/*<div style={{backgroundColor: `#${this.state.organiser[i].color}`, padding: 10}}>{this.state.organiser[i].showname}</div>*/}
									</span>
									</div>
								</div>
							}
							<div className="schedule-event-sm d-block d-md-none" style={{backgroundColor: `#${this.state.organiser[i].color}`}}>
								<span>
									{this.state.organiser[i].showname}<br />
									{moment(dateLocal(this.state.organiser[i].date)*1000).format("DD MMM")}
								</span>
							</div>
						</React.Fragment>
					}
				}
				if( !found ) return <>
					<div className="schedule-event-blank d-none d-md-block" style={{backgroundColor: `#ffffff`, color: '#000000'}}>
						<span>
							{moment(date).format("DD MMM")}
						</span>
					</div>
					<div className="schedule-event-blank-sm d-block d-md-none" style={{backgroundColor: `#ffffff`, color: '#000000'}}>
						<span>
							{moment(date).format("DD MMM")}
						</span>
					</div>
					
				</>;
			}
			return null;
		};

		const schedule = Object.keys(this.state.schedule).map((e,i) => {
			return (
				<React.Fragment key={i}>
					<li>
						<div className="timeline-time text-end"> <span className="time d-inline-block">{moment(this.state.schedule[e].date).format("DD MMM")}</span> </div>
						<div className="timeline-icon"></div>
						<div className="timeline-body">
							<div className="d-flex align-items-top timeline-main-content mt-0">
								<div className="flex-fill">
									<div className=" align-items-center">
										<div className="mt-sm-0 mt-2">


											<div className="card custom-card">
												<div className="card-header justify-content-between p-0">
													<div className="card-title">{this.state.schedule[e].showname.length>0?this.state.schedule[e].showname:moment(this.state.schedule[e].date).format("dddd, Do MMMM")} </div>
													<div className="dropdown d-flex">
														<small className="mt-1"><FontAwesomeIcon icon="clock" />&nbsp;{this.timeAgo(dateLocal(this.state.schedule[e].start))}</small>&nbsp;&nbsp;
														<Button size="sm" onClick={()=>this.organiserEdit(this.state.schedule[e].oid, this.state.schedule[e].date)} className="py-1 px-2 m-0 mb-2">Edit Event</Button>&nbsp;&nbsp;
													</div>
												</div>
											</div>

											<Row className="gx-0 pb-3">
												<Col md={3} className="text-center">
													{(this.state.schedule[i].cover && this.state.schedule[i].cover.length > 0 ) ?
														<div className="d-none d-md-block mb-2" style={{border: '1px solid #000000', /*backgroundColor: `#${this.state.schedule[i].color}`*/
															/*backgroundImage: `url(https://cloud.ultrastream.io${this.state.schedule[i].cover})`, backgroundSize: 'cover', color: '#000000', marginLeft: 10, marginRight: 10*/}}>
															{/*<div className="schedule-event p-0" /*style={{backgroundColor: `#${this.state.schedule[i].color}`}}*>
																{/*<span>
																	{this.state.schedule[i].showname&&this.state.schedule[i].showname.length>0?this.state.schedule[i].showname:moment(dateLocal(this.state.schedule[i].date)*1000).format("dddd")}<br />
																	{moment(dateLocal(this.state.schedule[i].date)*1000).format("DD MMM")}
																	{/*<div style={{backgroundColor: `#${this.state.schedule[i].color}`, padding: 10}}>{this.state.schedule[i].showname}</div>*}
																</span>*}
															</div>*/}
															<EnImage src={`https://cloud.ultrastream.io${this.state.schedule[i].cover}?d=${Math.floor(Date.now()/1000)}`} alt="Custom User Flyer" width="100%"  />
														</div>
													:
														<div className="d-none d-md-block mb-2" style={{border: '1px solid #000000', /*backgroundColor: `#${this.state.schedule[i].color}`*/
															backgroundImage: `url(https://cloud.ultrastream.io/images/components/background.png)`, backgroundSize: 'cover', color: '#000000', marginLeft: 10, marginRight: 10}}>
															<div className="schedule-event p-0" style={{backgroundColor: `#${this.state.schedule[i].color}`}}>
																<span>
																	{this.state.schedule[i].showname&&this.state.schedule[i].showname.length>0?this.state.schedule[i].showname:moment(dateLocal(this.state.schedule[i].date)*1000).format("dddd")}<br />
																	{moment(dateLocal(this.state.schedule[i].date)*1000).format("DD MMM")}
																	{/*<div style={{backgroundColor: `#${this.state.schedule[i].color}`, padding: 10}}>{this.state.schedule[i].showname}</div>*/}
																</span>
															</div>
														</div>
													}
													
													<Button size="sm" onClick={()=>this.clickuploadFlyer(Math.floor(dateUTCShedule(this.state.schedule[i].date).getTime()/1000))}>Upload Flyer</Button>
												</Col>
												<Col className="ps-3">
													<h6>Showname: {this.state.schedule[i].showname&&this.state.schedule[i].showname.length>0?this.state.schedule[i].showname:moment(dateLocal(this.state.schedule[i].date)*1000).format("dddd")}, {moment(dateLocal(this.state.schedule[i].date)*1000).format("DD MMM")}</h6>
													<h6><small><FontAwesomeIcon icon="clock" /> Starts {this.timeAgo(dateLocal(this.state.schedule[e].start))}</small></h6>
													<h6><small>Description:</small></h6>
													{this.state.schedule[e].description?
														<Blocks blocks={this.state.schedule[e].description} />
														:
														<>No Description Set</>
													}
													<h6><small>Genres:</small></h6>
													<Genres genres={this.state.schedule[e]?.genres.length>0?this.state.schedule[e]?.genres:['Open House']} />

												</Col>
											</Row>
											
											<Row className="gx-0">
												<Col>
													<Scheduler version="full" service={this.state.service.id} event={{...this.state.schedule[e]}} close={this.close} changeZone={this.scheduleZone} />
												</Col>
											</Row>
										</div>
										<div className=""> <span className="float-end badge bg-light text-muted timeline-badge mt-2  rounded-1"> 07:00 AM </span> </div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</React.Fragment>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Schedule</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
                <Col xs={12}>
									<div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">{this.state.service.name} Schedule</span>
													<p className="fs-13 text-muted mb-0">Watch the live stream</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div className="card-body" style={{maxWidth: 1200, textAlign: 'center'}}>
											<Calendar onChange={this.setDate} onActiveStartDateChange={this.setMonth} value={this.state.date} tileContent={shows} maxDetail="month" next2Label='' prev2Label='' />
										</div>
                  </div>
									
								</Col>
								<Col xs={12}>
									<ul className="timeline list-unstyled">
										{schedule}
									</ul>
								</Col>

              </Row>
            </div>
					</div>
				}
				{/*this.state.scheduleadd && <ScheduleAdd show={this.state.scheduleadd} close={this.close} channel={this.state.channel} /> }
				{this.state.scheduleedit.organiser!==false && <ScheduleEdit show={this.state.scheduleedit.organiser>0} close={this.close} schedule={this.state._schedule[this.state.scheduleedit.organiser].events[this.state.scheduleedit.id]} channel={this.state.channel} /> }*/}



				{this.state.showModal!==false && this.state.showModal.option==='organiseredit' && <OrganiserEdit show={this.state.showModal.option==='organiseredit'} close={this.close} organiser={this.state.organiser[this.state.showModal.id]} service={this.props.service} /> }
				{/*{this.state.organiserImages!==false && <OrganiserImages show={this.state.organiserImages>0} close={this.close} organiser={this.state.organiser[this.state.organiserImages-1]} channel={this.state.channel} complete={()=>{this.complete();}} /> }
				<input id="upload_flyer" type="file" onChange={(e)=>this.uploadImage(e,'flyer')} style={{display: 'none'}} />*/}
				<input id="upload_flyer" type="file" onChange={(e)=>this.uploadFlyer(e,'flyer')} style={{display: 'none'}} />
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceSchedule service={service} {...props} />
}
export default Stream;